document.addEventListener('DOMContentLoaded', function() {
    const anchorLinks = document.querySelectorAll('.anchors-wrapp a');
    const pageHeader = document.getElementById('pageheader');

    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            anchorLinks.forEach(item => item.classList.remove('active'));
            this.classList.add('active');

            let targetKey = this.getAttribute('href');
            
            if (targetKey.startsWith('#')) {
                targetKey = targetKey.slice(1);
            }

            const targetElement = document.querySelector(`[data-anchor-id="${targetKey}"]`);
            
            if (targetElement) {
                const headerHeight = pageHeader ? pageHeader.offsetHeight : 0;
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - headerHeight;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
});
